import { registerLazyNotificationRenderer } from "@/entities/notification"

registerLazyNotificationRenderer(
	"daily-question",
	() => import("../ui/daily-question-popup"),
)
